define(function(require) {
	const tpl = require('../templates/t_lov_description_card.hbs');
	const standardCardView = require('civicsViews/card_views/standard/views/v_cpv_card_view');
	const menuListView = require('./v_cpv_card_menu');

	return Marionette.LayoutView.extend({
		childEvents:{
			'actionItemClicked':'actionItemClicked',
			'saveCardEdits':'saveCardEdits',
		},
		template: tpl,
		regions: {
			cardRegion:'@ui.cardDiv',
			menuRegion:'@ui.menuDiv'
		},
		ui:{
			menuDiv:'.card-menu',
			cardDiv:'.main-card',
			menuButton:'.btn-actions-list',
			actionButton:'.action-button'
		},
		events:{
			'click @ui.menuButton':'toggleMenu',
			'click @ui.actionButton':'actionButtonClicked'
		},
		//Marionette Functions Start
		initialize:function(options){
			//console.log('description card view init');
			if(options.card){
				this.cardCollection = options.card;

				if (options.isModal) {
					this.cardCollection.isModal = true;
				}
			}
			//remove the card data. it's not useful to us and it's (potentially) a lot of overhead.
			delete options.card;
			this.config = options;
		},
		onShow:function(){
			if(this.cardCollection){
				var cardView = new standardCardView(this.cardCollection);
				this.cardRegion.show(cardView);
			}
			if(this.config.menu && !_.isEmpty(this.config.menu)){
				var menuView = new menuListView({
					menu:this.config.menu
				});
				this.menuRegion.show(menuView);
			}
			else {
				this.ui.menuButton.hide();
			}
		},
		templateHelpers: function () {
			var hasLink = (this.config.headerButton && this.config.headerButton.link != null);
			var link = this.getLink(hasLink);
			return {
				sectionID:this.config.sectionID,
				title:this.config.title,
				cardClass:this.config.cardClass,
				hasMenu: this.config.menu,
				hasButton: this.config.headerButton,
				hasTitle: this.config.title != null,
				headerButton:this.config.headerButton,
				secondaryButton: this.config.secondaryButton,
				hasSecondaryButton: this.config.secondaryButton,
				hasLink: hasLink,
				linkOnClick: link,
				hasViewRelatedRecordButton: this.config.viewRelatedRecordButton,
				viewRelatedRecordButton: this.config.viewRelatedRecordButton,
				belowSecondaryButton: this.config.belowSecondaryButton,
				hasBelowSecondaryButton: this.config.belowSecondaryButton,
				hasBelowThirdButton: this.config.belowThirdButton,
				belowThirdButton: this.config.belowThirdButton
			}; 
		},
		getLink: function(hasLink) {
			var returnLink = '';

			if (hasLink) {
				returnLink = "onclick=\"if(!event.ctrlKey) window.location.assign('" + this.config.headerButton.link + "'); " + 
				" else window.open('" + this.config.headerButton.link + "');\"" +
				" oncontextmenu=\"this.href='" + this.config.headerButton.link + "'\"" +
				" onmousemove=\"this.href='javascript:void(0)'\"";
			}

			if (hasLink  && this.cardCollection.isModal) {
				returnLink = "onclick=\"window.open('"+ this.config.headerButton.link + "');\"";
			}

			return returnLink;
		},
		//Marionette Functions End
		actionButtonClicked:function(e){
			if(e){
				e.stopPropagation();
				e.preventDefault()
			}
			//console.log('action button clicked');
			this.triggerMethod('actionItemClicked', this.getActionButtonValue(e.currentTarget));
		},
		getActionButtonValue: function(currentTarget) {
			if($(currentTarget) && $(currentTarget).hasClass('additional-button'))
				return this.config.secondaryButton.value
			else if ($(currentTarget) && $(currentTarget).hasClass('related-record-button'))
				return this.config.viewRelatedRecordButton.value 
			else if ($(currentTarget) && $(currentTarget).hasClass('below-secondary-button'))
				return this.config.belowSecondaryButton.value 
			else if ($(currentTarget) && $(currentTarget).hasClass('below-tertiary-button'))
				return this.config.belowThirdButton.value 
			else
				return this.config.headerButton.value;
        },
		actionItemClicked:function(childView,optionValue){
			//console.log('lov option clicked');
			this.triggerMethod('actionItemClicked',optionValue);
		},
		saveCardEdits:function(childView,model, promise){
			//console.log('card description lov saving edits');
			this.triggerMethod('saveCardEdits',model,promise);
		},
		toggleMenu:function(e){
			if(e){
				e.stopPropagation();
				e.preventDefault();
			}
			if(this.ui.menuDiv.hasClass('hide')){
				this.ui.menuDiv.removeClass('hide');
			} else {
				this.ui.menuDiv.addClass('hide');
			}
		}
	});
});
